// extracted by mini-css-extract-plugin
export default {"productGrid":"F0-z","centerLink":"G0-z","productSection":"H0-z","item":"I0-z","ctaButton":"J0-z"};